import m from "./../../../dist/es2015/locales/zh_Hant.js";
export const am5locales_zh_Hant = m;